"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscreteRangeRaster = void 0;
const raster_1 = require("./raster");
const metrics_service_1 = require("./metrics-service");
class DiscreteRangeRaster extends raster_1.Raster {
    constructor(data, bounds, colorRange, options) {
        super(data, bounds, colorRange, options);
        this.ranges = this.computeRanges();
        this.imageData = this.computeImagedata();
    }
    computeRanges() {
        const ordered = this.orderedValues;
        const count = this.colors.length;
        let min = ordered[0];
        let max = ordered[ordered.length - 1];
        const bucketsEdges = [];
        const deviations = this.options.deviations || 0;
        if (deviations) {
            const average = metrics_service_1.metricsService.average(ordered);
            const std = metrics_service_1.metricsService.standardDeviation(ordered);
            const stdMin = average - deviations * std;
            const stdMax = average + deviations * std;
            // Ensure that our min/max values never fall outside of what is actually possible
            if (stdMin > min) {
                min = stdMin;
            }
            if (stdMax < max) {
                max = stdMax;
            }
        }
        const step = (max - min) / count;
        for (let i = 1; i <= count; i += 1) {
            bucketsEdges.push(min + step * i);
        }
        return bucketsEdges;
    }
}
exports.DiscreteRangeRaster = DiscreteRangeRaster;
